import { Box, IconButton } from '@mui/material';
import React from 'react';
import CustomInput from '../../components/inputs/CustomInputs';
import DeleteIcon from '@mui/icons-material/Delete';

const AddProductProblem = ({ fields, setFields, loading }) => {
    const handleDeleteItem = (index) => {
        const updatedItems = fields?.problems?.filter((_, inx) => inx !== index);
        setFields({ ...fields, err: "", problems: updatedItems });
    };

    return (
        <Box mt={2}>
            {fields?.problems?.length > 0 &&
                fields?.problems?.map((val, inx) => {
                    if (!val) return null;
                    return (
                        <Box key={inx} display={"flex"} flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"} width={"100%"} gap={2}>
                            <Box width={"57%"}>
                                <CustomInput
                                    disabled={loading}
                                    value={val.name}
                                    onChange={(e) => {
                                        const updatedproblems = [...fields?.problems];
                                        updatedproblems[inx] = {
                                            ...updatedproblems[inx],
                                            name: e.target.value,
                                        };
                                        setFields({ ...fields, err: "", problems: updatedproblems });
                                    }}
                                    type="text"
                                    label={"Problem Name*"}
                                />
                            </Box>
                            <Box width={"47%"}>
                                <CustomInput
                                    disabled={loading}
                                    value={val.warrenty}
                                    onChange={(e) => {
                                        const updatedproblems = [...fields?.problems];
                                        updatedproblems[inx] = {
                                            ...updatedproblems[inx],
                                            warrenty: Number(e.target.value),
                                        };
                                        setFields({ ...fields, err: "", problems: updatedproblems });
                                    }}
                                    type="text"
                                    label={"Problem Warrenty Valid Years*"}
                                />
                            </Box>
                            <Box>
                                <IconButton
                                    color="error"
                                    onClick={() => handleDeleteItem(inx)}
                                    aria-label="delete"
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </Box>
                        </Box>
                    );
                })}
        </Box>
    );
};

export default AddProductProblem;
